module.exports = __webpack_public_path__ + "img/1.5b0b6ad1.svg";